<template>
  <el-row style="height: 100%" type="flex" align="center">
    <el-col
      :span="12"
      class="d-flex align-items-center justify-content-start text-white"
      v-on:click.stop="toggleNavs"
    >
      <div class="logo-slogan d-flex align-items-center">
        <img class="header-logo" src="../../../assets/images/slogan/logo.png" />
        <span class="header-words">用电管家</span>
      </div>
      <i
        class="el-icon-s-fold cursor-pointer"
        style="margin-left: 2rem"
        v-on:click.stop="toggleNavs"
      ></i>
    </el-col>
    <el-col
      :span="12"
      type="flex"
      class="d-flex align-items-center right-container justify-content-end"
    >
      <div class="d-flex text-white">
        <el-dropdown @command="selectSkin">
          <div :class="[skinType == 0 ? 'text-white' : 'text-darkblue']">
            <i
              class="iconfont header-icon"
              :class="skinType ? 'iconskin-dark' : 'iconskin'"
            ></i>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="0">冬日素雪</el-dropdown-item>
            <el-dropdown-item :command="1">深秋高天</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="split-line"></div>
      <div class="text-white">
        <el-badge :value="warnCount" class="item cursor-pointer">
          <i
            class="el-icon-bell text-white warn-icon header-icon"
            v-on:click="showWarnList"
          ></i>
        </el-badge>
        <span style="margin-left: 20px">{{ dateTime }}</span>
      </div>
      <div class="split-line"></div>
      <div class="d-flex text-white align-items-center">
        <el-dropdown @command="setPersonal">
          <el-avatar
            v-if="info.F_HeadIcon"
            :src="`${baseUrl}${info.F_HeadIcon}`"
            class="cursor-pointer"
          ></el-avatar>
          <el-avatar
            v-else
            size="small"
            class="cursor-pointer"
            src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"
          ></el-avatar>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item icon="el-icon-user" :command="0"
              >个人设置</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
        <span style="margin-left: 16px">{{ info.F_RealName }}</span>
        <i
          class="iconfont icontuichu quit-icon cursor-pointer header-icon"
          v-on:click="quitSystem"
        ></i>
      </div>
    </el-col>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      :class="{ dark: skinType }"
    >
      <span>是否退出系统</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="mini">取 消</el-button>
        <el-button type="primary" size="mini" @click="sureQuitSys"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </el-row>
</template>
<script>
import { formatDate } from '@/utils/utils';
import { getPersonalInfo, getWarnCount } from '@/api/personal-center/setting';
import { BASE_URL } from '@/utils/request/request';
import { _BASE_Configuration } from '@/const/values.js';
export default {
  name: 'home-header',
  data() {
    return {
      intervalId: 0,
      dialogVisible: false,
      baseUrl: BASE_URL,
      formatDate,
      isCollapse: true,
      dateTime: formatDate(new Date(), 'yyyy/MM/dd HH:mm:ss'),
      info: {},
      warnCount: 0,
      isShow: _BASE_Configuration
    };
  },
  created() {
    this.requestWarnCount();
    this.getDateTime();
    this.requestPersonalInfo();
  },
  mounted() {
    // 定时器
    this.requestWarnCount();
    // this.intervalId = setInterval(() => {
    //   this.requestWarnCount();
    // }, 6000);
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
  computed: {
    accountId() {
      return this.$store.getters.accountId;
    },
    skinType() {
      return this.$store.getters.skinType;
    }
  },
  methods: {
    showWarnList() {
      this.$router.push({
        name: 'alarm-table'
      });
    },
    setPersonal(item) {
      console.log('bs-------------->', item);
      switch (item) {
        case 0:
          this.routeToPersonalSetting();
          break;
        default:
          break;
      }
    },
    selectSkin(type) {
      console.log('sb------------>', type);
      this.$store.commit('app/SKIN_TYPE', type);
    },
    requestPersonalInfo() {
      getPersonalInfo({
        UIDstr: this.accountId
      }).then((res) => {
        this.info = res.list[0];
      });
    },
    requestWarnCount() {
      debugger;
      if (isShow) {
        getWarnCount()
          .then((res) => {
            this.warnCount = parseInt(res.Count, 10);
          })
          .catch(() => {})
          .then(() => {});
      }
    },
    // 退出系统
    quitSystem() {
      this.dialogVisible = true;
    },
    toggleNavs() {
      this.isCollapse = !this.isCollapse;
      this.$emit('isNavCollapse', this.isCollapse);
    },
    getDateTime() {
      this.dateTime = formatDate(new Date(), 'yyyy/MM/dd HH:mm:ss');
      setTimeout(this.getDateTime, 1000);
    },
    sureQuitSys() {
      this.dialogVisible = false;
      localStorage.removeItem('userInfo');
      this.$store
        .dispatch('user/logout', null, { root: true })
        .then(() => {
          if (this.$route.name == 'equipment_details') {
            this.$router.push({
              name: 'Login',
              params: { type: 2 } // 声音跳转到登录页的类型，如果为2则为登录页跳转设备工况详情页面
            });
          } else {
            this.$router.replace({
              name: 'Login'
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleCommand(command) {
      switch (command) {
        case 0:
          console.log('uuuuuuuuuu');
          this.routeToPersonalSetting();
          break;
        default:
          break;
      }
    },
    routeToPersonalSetting() {
      console.log('jijijijijij');
      this.$router.push({
        path: 'personal-center/personal-info-setting'
      });
    },
    showDialog(command) {
      console.log('dialogVisible');
      this.$emit('dialogVisible', command);
    }
  }
};
</script>
<style scoped>
.logo-slogan {
  font-size: 26px;
}

.header-logo {
  height: 22px;
}

.header-slogan {
  height: 32px;
}

.header-words {
  margin-left: 1rem;
  line-height: 1;
}

.split-line {
  width: 1px;
  height: 30px;
  background-color: rgba(255, 255, 255, 0.65);
  margin: 0 10px;
}

.right-container {
  font-size: 16px;
}

.header-icon {
  font-size: 24px;
}

.quit-icon {
  margin-left: 20px;
  font-size: 20px;
}

.text-darkblue {
  color: #2e9bf3;
}
</style>